import React from "react";

const UploadLive: React.FC = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="bx-cloud-upload">
      <path
        id="Vector"
        d="M13 19.5V15.5H16L12 10.5L8 15.5H11V19.5H13Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        id="Vector_2"
        d="M7 19.5H9V17.5H7C5.346 17.5 4 16.154 4 14.5C4 13.096 5.199 11.744 6.673 11.485L7.254 11.383L7.446 10.825C8.149 8.774 9.895 7.5 12 7.5C14.757 7.5 17 9.743 17 12.5V13.5H18C19.103 13.5 20 14.397 20 15.5C20 16.603 19.103 17.5 18 17.5H15V19.5H18C20.206 19.5 22 17.706 22 15.5C21.9985 14.6036 21.6966 13.7336 21.1427 13.0288C20.5888 12.3241 19.8147 11.8253 18.944 11.612C18.507 8.17 15.56 5.5 12 5.5C9.244 5.5 6.85 7.111 5.757 9.65C3.609 10.292 2 12.32 2 14.5C2 17.257 4.243 19.5 7 19.5Z"
        fill="white"
        fillOpacity="0.6"
      />
    </g>
  </svg>
);

export default UploadLive;
